import { render, staticRenderFns } from "./ResellerPasswordForgot.vue?vue&type=template&id=3837be70&"
import script from "./ResellerPasswordForgot.vue?vue&type=script&lang=js&"
export * from "./ResellerPasswordForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3837be70')) {
      api.createRecord('3837be70', component.options)
    } else {
      api.reload('3837be70', component.options)
    }
    module.hot.accept("./ResellerPasswordForgot.vue?vue&type=template&id=3837be70&", function () {
      api.rerender('3837be70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ResellerPasswordForgot.vue"
export default component.exports